import { render, staticRenderFns } from "./clothes-color.vue?vue&type=template&id=6a869b00&scoped=true&"
import script from "./clothes-color.vue?vue&type=script&lang=js&"
export * from "./clothes-color.vue?vue&type=script&lang=js&"
import style0 from "./clothes-color.vue?vue&type=style&index=0&id=6a869b00&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a869b00",
  null
  
)

export default component.exports